import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const OrderpickingMovePalletRoute: Route = {
  path: 'orderpicking/update',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/move-pallet.component').then((m) => m.OrderpickingMovePalletComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
